import { UserflowTriggers } from '@/services/userflow/userflow';
import { onBeforeMount, onBeforeUnmount } from 'vue';

export function useWindowMessage(message: UserflowTriggers, callback: () => void) {
  const messageHandler = (event: MessageEvent) => {
    if (event.origin === window.origin && event.data === message) {
      callback();
    }
  };

  onBeforeMount(() => {
    window.addEventListener('message', messageHandler);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('message', messageHandler);
  });
}
